import { IPassenger } from "@/core/interfaces/passenger.interface";
import { AdditionalPassengerField, ExtendedPrice } from "@/core/types/flight";
import { IConfirmBooking } from "@/core/types/flight/FlightBookingForm";

export const BookingErrorMessage =
  "Booking no longer exist.Search and try to book again.";

export interface Meal {
  code: string;
  description: string;
  amount: ExtendedPrice;
}

export interface Seat {
  seat_number: string;
  seat_status: string;
  amount: ExtendedPrice;
}

export interface SeatRow {
  row_number: string;
  seats: Seat[];
}

export type SeatState = "AVAILABLE" | "SELECTED" | "RESERVED";

export interface SeatDetails {
  cabin_type: string;
  seat_rows: SeatRow[];
}

export interface AddOns {
  meal: Meal[];
  seat: SeatDetails[];
}

export interface SegmentDetails {
  public_id: string;
  flight_number: string;
  departure_date_time: string;
  arrival_date_time: string;
  departure_short_code: string;
  arrival_short_code: string;
}

export interface Segment {
  segment_details: SegmentDetails;
  add_ons: AddOns;
}

export interface Baggage {
  code: string;
  description: string;
  amount: ExtendedPrice;
}

export interface Addons {
  baggage: Baggage[];
}

export interface LegDetails {
  public_id: string;
  departure_date_time: string;
  arrival_date_time: string;
  departure_short_code: string;
  arrival_short_code: string;
  segments: Segment[];
}

export interface AvailableAddOns {
  leg_details: LegDetails;
  addons: Addons;
}

export interface SpecialRequest {
  baggage_request: BaggageRequest[] | null;
  meal_request: MealRequest[] | null;
  seat_request: SeatRequest[] | null;
}

export interface BaggageRequest {
  baggage_code: string;
  leg_public_id: string;
  passenger_public_id: string;
}

export interface MealRequest {
  meal_code: string;
  segment_public_id: string;
  passenger_public_id: string;
}

export interface SeatRequest {
  seat_number: string;
  segment_public_id: string;
  passenger_public_id: string;
}

export interface ConfirmAddOns extends IConfirmBooking {
  special_request: SpecialRequest | null;
  is_addons_skipped: boolean;
}

export interface PassengerAdditionalFieldsGroup {
  name: string;
  displayName: string;
  data: AdditionalPassengerField[];
  hasMandatoryField: boolean;
}

export enum PassengerFieldTypes {
  TEXT = "TEXT",
  NUMBER = "NUMBER",
  CHOICE = "CHOICE",
  DATE = "DATE",
  MOBILE_NUMBER = "MOBILE_NUMBER",
  EMAIL = "EMAIL",
  ALPHA_ONLY = "ALPHA_ONLY",
  ALPHA_NUMERIC = "ALPHA_NUMERIC",
  CHECKBOX = "CHECKBOX",
  TEXTAREA = "TEXTAREA",
  MULTI_SELECT = "MULTI_SELECT",
  SWITCH = "SWITCH",
  READ_ONLY = "READ_ONLY",
}

export interface PassengerDetails extends IPassenger {
  date_of_birth: string;
  passport_expiry_date: string;
}
